import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _slicedToArray from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/createClass";
import createLogger from './logger';

var Reporter = /*#__PURE__*/function () {
  function Reporter(options, reporters) {
    _classCallCheck(this, Reporter);

    // 上报队列
    this.$queue = []; // 是否延迟上报

    this.delay = false;
    /**
     * @private
     */

    this.$reporters = reporters;
    this.delay = (options === null || options === void 0 ? void 0 : options.delay) || false;
    this.logger = createLogger((options === null || options === void 0 ? void 0 : options.silent) || false);
    this.runMiddleware(function (reporter) {
      if (reporter.init) {
        reporter.init(options);
      }
    });
  }

  _createClass(Reporter, [{
    key: "init",
    value: function init(options) {
      this.delay = (options === null || options === void 0 ? void 0 : options.delay) || false;
    }
    /**
     * 设置额外上报参数
     */

  }, {
    key: "setExtraParams",
    value: function setExtraParams(params) {
      this.runMiddleware(function (reporter) {
        reporter.setExtraParams(params);
      });
    }
    /**
     * 上报就绪
     */

  }, {
    key: "ready",
    value: function ready() {
      this.delay = false;
      this.runMiddleware(function (reporter) {
        reporter.ready();
      });

      while (this.$queue.length) {
        var _this$$queue$pop = this.$queue.pop(),
            _this$$queue$pop2 = _slicedToArray(_this$$queue$pop, 2),
            params = _this$$queue$pop2[0],
            type = _this$$queue$pop2[1];

        this.report(params, type);
      }
    }
    /**
     * 上报
     * @param params 上报参数
     * @param type 上报类型
     */

  }, {
    key: "report",
    value: function report(params) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'expose';

      if (this.delay) {
        this.$queue.push([params, type]);
        return;
      }

      this.logger(type, params);
      this.runMiddleware(function (reporter) {
        reporter.report(params, type);
      });
    }
    /**
     * 曝光上报
     * @param params 上报参数
     */

  }, {
    key: "expose",
    value: function expose(params) {
      this.report(params, 'expose');
    }
    /**
     * 点击上报
     * @param {ReportParams} params 上报参数
     */

  }, {
    key: "click",
    value: function click(params) {
      this.report(params, 'click');
    }
    /**
     * 执行中间件方法
     * @param fn {function}
     */

  }, {
    key: "runMiddleware",
    value: function runMiddleware(fn) {
      if (this.$reporters && Array.isArray(this.$reporters)) {
        this.$reporters.forEach(function (reporter) {
          fn(reporter);
        });
      }
    }
  }]);

  return Reporter;
}();
/**
 * 创建上报器
 * @param {ReporterOptions} options 上报配置
 * @param {Array} reporters 上报器
 *
 * @return {Reporter}
 */


export { Reporter as default };
export function createReporter(options, reporters) {
  return new Reporter(options, reporters);
}